module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-11-13086543256cd870580e5bd951d04312.jpg";